import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { writeLastIdentity } from "./lastIdentity";

// #3256 -- remember the signed-in scribe's non-secret identity (sub + display
// claims, never a token) so a restart or expired-token reload with no network
// can keep running as them (see lastIdentity.js). Only a real, authenticated
// session writes it. Renders nothing.
export default function LastIdentityWriter() {
  const auth = useAuth();
  const profile = auth.isAuthenticated ? auth.user?.profile : null;
  useEffect(() => {
    if (profile?.sub) writeLastIdentity(profile);
  }, [profile]);
  return null;
}
